import React from 'react';
import PageTitle from '../../layouts/PageTitle';
import '../../../scss/pages/_growthcenter-list.scss';
import menuimg from "../../../images/product/cs.jpg"

const GrowthCenter = () => {
    return (
        <div className='growth-center'>

            <PageTitle
                title="Growth Center"
                subtitle="Choose a goal to grow your business"
            /> 


            <div className="row">
                <div className="col-md-3 col-lg-3">
                    <div className="card rounded-0">
                        <div className="card-body growth-body">
                            <div className='d-flex justify-content-center w-100'>
                                <img className='img-fluid w-50 pb-3' src={menuimg} alt="" />
                           </div>
                            <div className="d-grid">
                                <b className='fs-4 text-center'>hubpicks</b>
                                <small className='text-center'>Enhance your branding</small>
                            </div>
                            <hr />
                            <ul>
                                <li>Increase Awareness of your listing  amazing nearby customers by 2x. </li>
                                <li>Get shown on a dedicated swimlane (horizontale listing) on the restaurant listing page</li>
                                <li>Pay a fixed fee per month</li>
                            </ul>

                            <button className='btn btn-square btn-secondary mt-5 py-2'>Continue to Booking</button>
                        </div>
                     </div>
                </div>
                <div className="col-md-3 col-lg-3">
                    <div className="card rounded-0">
                        <div className="card-body growth-body">

                            <div className='d-flex justify-content-center w-100'>
                                <img className='img-fluid w-50 pb-3' src={menuimg} alt="" />
                            </div>

                            <div className="d-grid">
                                <b className='fs-4 text-center'>hubclicks</b>
                                <small className='text-center'>Enhance your branding</small>
                            </div>
                            <hr />
                            <ul>
                                <li>Increase Awareness of your listing  amazing nearby customers by 2x. </li>
                                <li>Get shown on a dedicated swimlane (horizontale listing) on the restaurant listing page</li>
                                <li>Pay a fixed fee per month</li>
                            </ul>

                            <button className='btn btn-square btn-secondary mt-5 py-2'>Continue to Booking</button>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-lg-3">
                    <div className="card rounded-0">
                        <div className="card-body growth-body">

                            <div className='d-flex justify-content-center w-100'>
                                <img className='img-fluid w-50 pb-3' src={menuimg} alt="" />
                            </div>

                            <div className="d-grid">
                                <b className='fs-4 text-center'>hubpromo</b>
                                <small className='text-center'>Enhance your branding</small>
                            </div>
                            <hr />
                            <ul>
                                <li>Increase Awareness of your listing  amazing nearby customers by 2x. </li>
                                <li>Get shown on a dedicated swimlane (horizontale listing) on the restaurant listing page</li>
                                <li>Pay a fixed fee per month</li>
                            </ul>

                            <button className='btn btn-square btn-secondary mt-5 py-2'>Continue to Booking</button>
                        </div>
                    </div>
                </div>
            </div>


            
        </div>
    );
};

export default GrowthCenter;